import React from "react";
import { withStyles, Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import WithTooltip from "../..//WithTooltip";
import { Label as FormLabel } from "../../typography/FormLabel";
import { ThemeType, Classes } from "@theme";

export type FormElementProps = {
  children?: React.ReactElement<any>;
  disabled?: boolean;
  field?: React.ReactElement<any>;
  fullWidth?: boolean;
  id?: string;
  label?: string;
  required?: boolean;
  style?: React.CSSProperties;
  subLabel?: string;
  tooltip?: React.ReactNode;
};

type Props = FormElementProps & {
  classes: Classes<typeof styles>;
};

/**
 * Display left label and the field together inside grid items
 */
export function FormElement(props: Props) {
  const { classes, fullWidth } = props;
  const full = fullWidth !== false;
  const labelFr = full ? 12 : 4;
  const fieldFr = full ? 12 : !props.label || 8;

  const content = props.field ? props.field : props.children;

  if (!content) {
    throw new Error("missing content");
  }

  return (
    <>
      {props.label && (
        <Grid
          item
          xs={labelFr}
          style={{ display: "flex", flexWrap: "wrap" }}
          data-test-id={props["data-test-id"]}
        >
          <FormLabel color="textSecondary">
            {props.label}
            {props.required && <span style={{ color: "red" }}>&nbsp;*</span>}
          </FormLabel>
          {props.subLabel && (
            <Typography variant="caption" gutterBottom>
              {props.subLabel}
            </Typography>
          )}
        </Grid>
      )}

      <Grid
        item
        xs={fieldFr}
        className={classes.field}
        data-test="FormElementField"
        data-test-id={props.id}
        style={props.style}
      >
        <WithTooltip title={props.tooltip}>{content}</WithTooltip>
      </Grid>
    </>
  );
}

const styles = (theme: ThemeType) => ({
  field: {
    marginBottom: theme.spacing()
  }
});
const StyledElement = withStyles(styles as any)(FormElement);
export default StyledElement;
